import { LayoutFragmentsRenderModule, default as entryComponentsRender0 } from 'extensions/core/layout-fragments/front/layout-fragments-render.module';
import { LayoutFullWidthRenderModule, default as entryComponentsRender1 } from 'extensions/core/layout-full-width/front/layout-full-width-render.module';
import { LayoutHeaderFooterRenderModule, default as entryComponentsRender2 } from 'extensions/core/layout-header-footer/front/layout-header-footer-render.module';
import { LayoutVerticalSliderRenderModule, default as entryComponentsRender3 } from 'extensions/core/layout-vertical-slider/front/layout-vertical-slider-render.module';
import { PieceAnimatedMenuRenderModule, default as entryComponentsRender4 } from 'extensions/core/piece-animated-menu/front/piece-animated-menu-render.module';
import { PieceButtonRenderModule, default as entryComponentsRender5 } from 'extensions/core/piece-button/front/piece-button-render.module';
import { PieceFinalCountdownRenderModule, default as entryComponentsRender6 } from 'extensions/core/piece-final-countdown/front/piece-final-countdown-render.module';
import { PieceHudsonCarouselRenderModule, default as entryComponentsRender7 } from 'extensions/core/piece-hudson-carousel/front/piece-hudson-carousel-render.module';
import { PieceFragmentRenderModule, default as entryComponentsRender8 } from 'extensions/core/piece-fragment/front/piece-fragment-render.module';
import { PieceImageRenderModule, default as entryComponentsRender9 } from 'extensions/core/piece-image/front/piece-image-render.module';
import { PieceImageTextRenderModule, default as entryComponentsRender10 } from 'extensions/core/piece-image-text/front/piece-image-text-render.module';
import { PieceListRenderModule, default as entryComponentsRender11 } from 'extensions/core/piece-list/front/piece-list-render.module';
import { PieceMenuRenderModule, default as entryComponentsRender12 } from 'extensions/core/piece-menu/front/piece-menu-render.module';
import { PieceNewsletterRenderModule, default as entryComponentsRender13 } from 'extensions/core/piece-newsletter/front/piece-newsletter-render.module';
import { PieceProductRenderModule, default as entryComponentsRender14 } from 'extensions/core/piece-product/front/piece-product-render.module';
import { PieceProductCarouselRenderModule, default as entryComponentsRender15 } from 'extensions/core/piece-product-carousel/front/piece-product-carousel-render.module';
import { PieceSelectStoreLanguageRenderModule, default as entryComponentsRender16 } from 'extensions/core/piece-select-store-language/front/piece-select-store-language-render.module';
import { PieceSeparatorRenderModule, default as entryComponentsRender17 } from 'extensions/core/piece-separator/front/piece-separator-render.module';
import { PieceShowcaseRenderModule, default as entryComponentsRender18 } from 'extensions/core/piece-showcase/front/piece-showcase-render.module';
import { PieceTableRenderModule, default as entryComponentsRender19 } from 'extensions/core/piece-table/front/piece-table-render.module';
import { PieceTextRenderModule, default as entryComponentsRender20 } from 'extensions/core/piece-text/front/piece-text-render.module';
import { PieceVideoRenderModule, default as entryComponentsRender21 } from 'extensions/core/piece-video/front/piece-video-render.module';
import { SliceAccordionRenderModule, default as entryComponentsRender22 } from 'extensions/core/slice-accordion/front/slice-accordion-render.module';
import { SliceAbTestingRenderModule, default as entryComponentsRender23 } from 'extensions/core/slice-ab-testing/front/slice-ab-testing-render.module';
import { SliceFlexRenderModule, default as entryComponentsRender24 } from 'extensions/core/slice-flex/front/slice-flex-render.module';
import { SliceMarqueeRenderModule, default as entryComponentsRender25 } from 'extensions/core/slice-marquee/front/slice-marquee-render.module';
import { SliceSliderRenderModule, default as entryComponentsRender26 } from 'extensions/core/slice-slider/front/slice-slider-render.module';
import { SliceStackedRenderModule, default as entryComponentsRender27 } from 'extensions/core/slice-stacked/front/slice-stacked-render.module';
import { SliceTabsRenderModule, default as entryComponentsRender28 } from 'extensions/core/slice-tabs/front/slice-tabs-render.module';
import { SliceUserSegmentsRenderModule, default as entryComponentsRender29 } from 'extensions/core/slice-user-segments/front/slice-user-segments-render.module';
import { PieceCardHoverRenderModule, default as entryComponentsRender30 } from 'extensions/st/piece-card-hover/front/piece-card-hover-render.module';
import { PieceExternalProviderAppsRenderModule, default as entryComponentsRender31 } from 'extensions/st/piece-external-provider-apps/front/piece-external-provider-apps-render.module';
import { PieceHudsonRenderModule, default as entryComponentsRender32 } from 'extensions/st/piece-hudson/front/piece-hudson-render.module';
import { PieceLottieRenderModule, default as entryComponentsRender33 } from 'extensions/st/piece-lottie/front/piece-lottie-render.module';
import { PieceMarqueeRenderModule, default as entryComponentsRender34 } from 'extensions/st/piece-marquee/front/piece-marquee-render.module';
import { PieceMaxiLogoRenderModule, default as entryComponentsRender35 } from 'extensions/st/piece-maxi-logo/front/piece-maxi-logo-render.module';
import { PieceProductCarouselRecommendedRenderModule, default as entryComponentsRender36 } from 'extensions/st/piece-product-carousel-recommended/front/piece-product-carousel-recommended-render.module';
import { PieceProductBannerRenderModule, default as entryComponentsRender37 } from 'extensions/st/piece-product-banner/front/piece-product-banner-render.module';
import { PiecePopUpNewsletterRenderModule, default as entryComponentsRender38 } from 'extensions/st/piece-pop-up-newsletter/front/piece-pop-up-newsletter-render.module';
import { PieceEventsRenderModule, default as entryComponentsRender39 } from 'extensions/st/piece-events/front/piece-events-render.module';
import { PieceConcludedEventsRenderModule, default as entryComponentsRender40 } from 'extensions/st/piece-concluded-events/front/piece-concluded-events-render.module';
import { SliceDragRenderModule, default as entryComponentsRender41 } from 'extensions/st/slice-drag/front/slice-drag-render.module';

export const modules = [
  LayoutFragmentsRenderModule,
  LayoutFullWidthRenderModule,
  LayoutHeaderFooterRenderModule,
  LayoutVerticalSliderRenderModule,
  PieceAnimatedMenuRenderModule,
  PieceButtonRenderModule,
  PieceFinalCountdownRenderModule,
  PieceHudsonCarouselRenderModule,
  PieceFragmentRenderModule,
  PieceImageRenderModule,
  PieceImageTextRenderModule,
  PieceListRenderModule,
  PieceMenuRenderModule,
  PieceNewsletterRenderModule,
  PieceProductRenderModule,
  PieceProductCarouselRenderModule,
  PieceSelectStoreLanguageRenderModule,
  PieceSeparatorRenderModule,
  PieceShowcaseRenderModule,
  PieceTableRenderModule,
  PieceTextRenderModule,
  PieceVideoRenderModule,
  SliceAccordionRenderModule,
  SliceAbTestingRenderModule,
  SliceFlexRenderModule,
  SliceMarqueeRenderModule,
  SliceSliderRenderModule,
  SliceStackedRenderModule,
  SliceTabsRenderModule,
  SliceUserSegmentsRenderModule,
  PieceCardHoverRenderModule,
  PieceExternalProviderAppsRenderModule,
  PieceHudsonRenderModule,
  PieceLottieRenderModule,
  PieceMarqueeRenderModule,
  PieceMaxiLogoRenderModule,
  PieceProductCarouselRecommendedRenderModule,
  PieceProductBannerRenderModule,
  PiecePopUpNewsletterRenderModule,
  PieceEventsRenderModule,
  PieceConcludedEventsRenderModule,
  SliceDragRenderModule
];

export const entryComponents = [
  ...entryComponentsRender0,
  ...entryComponentsRender1,
  ...entryComponentsRender2,
  ...entryComponentsRender3,
  ...entryComponentsRender4,
  ...entryComponentsRender5,
  ...entryComponentsRender6,
  ...entryComponentsRender7,
  ...entryComponentsRender8,
  ...entryComponentsRender9,
  ...entryComponentsRender10,
  ...entryComponentsRender11,
  ...entryComponentsRender12,
  ...entryComponentsRender13,
  ...entryComponentsRender14,
  ...entryComponentsRender15,
  ...entryComponentsRender16,
  ...entryComponentsRender17,
  ...entryComponentsRender18,
  ...entryComponentsRender19,
  ...entryComponentsRender20,
  ...entryComponentsRender21,
  ...entryComponentsRender22,
  ...entryComponentsRender23,
  ...entryComponentsRender24,
  ...entryComponentsRender25,
  ...entryComponentsRender26,
  ...entryComponentsRender27,
  ...entryComponentsRender28,
  ...entryComponentsRender29,
  ...entryComponentsRender30,
  ...entryComponentsRender31,
  ...entryComponentsRender32,
  ...entryComponentsRender33,
  ...entryComponentsRender34,
  ...entryComponentsRender35,
  ...entryComponentsRender36,
  ...entryComponentsRender37,
  ...entryComponentsRender38,
  ...entryComponentsRender39,
  ...entryComponentsRender40,
  ...entryComponentsRender41
];
